import api from "../../api";

// GeeVee Conversations: two-way SMS between GeeVee and buyers
// (Christian, Monday 13432357091). Backend app `geevee_sms`.
const BASE = "/api/geevee-sms";

export const fetchGeeveeOverview = () =>
  api.get(`${BASE}/overview/`).then((r) => r.data);

export const fetchGeeveeConversations = (params = {}) =>
  api.get(`${BASE}/conversations/`, { params }).then((r) => r.data);

export const fetchGeeveeConversation = (id) =>
  api.get(`${BASE}/conversations/${id}/`).then((r) => r.data);

export const sendGeeveeText = (id, body) =>
  api.post(`${BASE}/conversations/${id}/send/`, { body }).then((r) => r.data);

// action: 'pause' (take over) | 'resume' (hand back to GeeVee) | 'close'
export const geeveeConversationAction = (id, action) =>
  api.post(`${BASE}/conversations/${id}/${action}/`).then((r) => r.data);

export const fetchGeeveeMatches = (id) =>
  api.get(`${BASE}/conversations/${id}/matches/`).then((r) => r.data);

// decision: 'approve' | 'reject'
export const decideGeeveeChange = (changeId, decision) =>
  api.post(`${BASE}/changes/${changeId}/${decision}/`).then((r) => r.data);

export const fetchGeeveeEligible = (days) =>
  api.get(`${BASE}/eligible/`, { params: days ? { days } : {} }).then((r) => r.data);

export const startGeevee = (contactIds) =>
  api.post(`${BASE}/start/`, { contact_ids: contactIds }).then((r) => r.data);
